<slotcom-wizard-modal
  [wizardModalData]="wizardModalData"
  [showArrows]="false"
  [showDots]="true"
  [tab]="tab"
  (currentTab)="tabChanged($event)">
  <ng-container *ngTemplateOutlet="step"> </ng-container>
</slotcom-wizard-modal>

<ng-template #step>
  <div class="info-background">
    <slotcom-p
      class="info-title"
      [bold]="true"
      [text]="
        tab !== 2
          ? ('home.daily-challenge.info.title-' + tab | translate)
          : ('home.daily-challenge.info-streak.title' | translate)
      "
      [shadowBorder]="true"></slotcom-p>

    <div class="info-steps-container">
      @for (s of steps[tab]; track s; let i = $index) {
        <ng-container *ngTemplateOutlet="infoStep; context: { textStep: s.textStep, imgStep: s.imgStep }">
        </ng-container>

        @if (i < steps[tab].length - 1) {
          <div
            theming
            themingGroup="dailychallenge"
            themingAsset="arrow"
            class="arrow-image"></div>
        }
      }
    </div>
  </div>
</ng-template>

<ng-template
  #infoStep
  let-textStep="textStep"
  let-imgStep="imgStep">
  <div class="info-step">
    <div
      class="step-image"
      data-testid="slotcom-dailyChallenge-information-step"
      theming
      themingGroup="dailychallenge"
      [themingAsset]="'step-' + imgStep"
      [themingOverride]="dailyChallengeInfoModalData?.data?.assets"></div>
    <slotcom-p
      class="step-text"
      [bold]="true"
      [text]="'home.daily-challenge.info' + textStep | translate: { x: threshold() }"
      [shadowBorder]="true"></slotcom-p>
  </div>
</ng-template>
